import { LegalPage, Section } from "./LegalPage";

export function AcceptableUse() {
  return (
    <LegalPage title="Acceptable Use Policy" lastUpdated="March 20, 2026">
      <Section title="1. Purpose">
        <p>This Acceptable Use Policy outlines the rules for using SimSense responsibly. Violations may result in account suspension or termination.</p>
      </Section>

      <Section title="2. Prohibited Conduct">
        <p><strong>Account Abuse</strong></p>
        <ul>
          <li>Create multiple free accounts to bypass usage limits</li>
          <li>Share login credentials with others</li>
          <li>Use automated tools to create accounts or bypass authentication</li>
        </ul>

        <p><strong>Data & Content</strong></p>
        <ul>
          <li>Upload files containing malware, viruses, or malicious code</li>
          <li>Scrape, crawl, or bulk-download data from the platform</li>
          <li>Reverse-engineer the SimSense analysis algorithms or coaching system</li>
          <li>Use the API in ways that degrade service for other users</li>
        </ul>

        <p><strong>Community</strong></p>
        <ul>
          <li>Impersonate other users, teams, setup shops, or brands</li>
          <li>Harass, threaten, or abuse other users through support tickets, reviews, or profiles</li>
          <li>Post false or misleading reviews on marketplace listings</li>
          <li>Spam the support system or community features</li>
        </ul>

        <p><strong>Marketplace</strong></p>
        <ul>
          <li>List setups you do not own or have rights to distribute</li>
          <li>Publish deceptive listings with false performance claims</li>
          <li>Manipulate the review or rating system</li>
          <li>Use the marketplace to distribute non-setup content</li>
        </ul>
      </Section>

      <Section title="3. Fair Use">
        <p><strong>Free Tier</strong></p>
        <ul>
          <li>3 coaching reports per month</li>
          <li>Reasonable upload volume</li>
          <li>Data retention per the stated policy</li>
        </ul>
        <p>Rate limits apply to all API endpoints. Excessive automated requests may be throttled or blocked.</p>
      </Section>

      <Section title="4. Reporting Violations">
        <p>If you encounter content or behavior that violates this policy:</p>
        <ul>
          <li>Use the in-app support system to report it</li>
          <li>Email support@outlierspeedco.com with details</li>
          <li>Include screenshots or evidence when possible</li>
        </ul>
      </Section>

      <Section title="5. Enforcement">
        <p>SimSense may take the following actions for violations:</p>
        <ul>
          <li><strong>Warning</strong> — First-time minor violations</li>
          <li><strong>Temporary suspension</strong> — Repeated or moderate violations</li>
          <li><strong>Permanent ban</strong> — Severe violations, fraud, or malicious activity</li>
        </ul>
        <p>Appeals may be submitted to support@outlierspeedco.com within 14 days.</p>
      </Section>

      <Section title="6. Security Disclosure">
        <p>If you discover a security vulnerability in SimSense:</p>
        <ul>
          <li>Do NOT publicly disclose it</li>
          <li>Report it to support@outlierspeedco.com</li>
          <li>Allow reasonable time for a fix before any disclosure</li>
          <li>We appreciate responsible disclosure and will credit researchers when appropriate</li>
        </ul>
      </Section>
    </LegalPage>
  );
}
